"use strict";

var LoggerInstance = require("js-logger").get("CheckoutApi");

var AbstractApi = require("../api/AbstractApi");

var StringConstants = require("../constants/StringConstants");

var Constants = require("../designer/Constants");

var ApiHelper = require("../shared/ApiHelper");

var CheckoutApi = class extends AbstractApi {
	removeFromCart(cartItemId, itemType, cartType) {
		return this.delete({
			url: "/api/carts",
			data: this._createCartAction(cartItemId, itemType, "remove", cartType)
		});
	}

	moveToCart(cartItemId, itemType, cartType) {
		return this.post({
			url: "/api/carts/move",
			data: this._createCartAction(cartItemId, itemType, "move", cartType)
		});
	}

	updateCart(updatedCartItems) {
		return this.put({
			url: "/api/carts",
			data: updatedCartItems
		});
	}

	addToCart(data) {
		return this.post({
			url: "/api/carts",
			data
		});
	}

	applyCoupon(couponData) {
		return this.post({
			url: "/api/carts/applycoupon",
			data: couponData
		});
	}

	applyOnePageCoupon(couponData) {
		return this.post({
			url: "/api/carts/applyonepagecoupon",
			data: couponData
		});
	}

	updateLastMinuteDonation(cartType, data) {
		return this.put({
			url: `/api/carts/${cartType}/donationupsell`,
			data
		});
	}

	updateCartDonation(cartType, updatedDonation) {
		var donation = _.cloneDeep(updatedDonation);

		// We want to only send the project code
		donation.project = donation.project["ProjectCode"];
		return this.put({
			url: `/api/carts/${cartType}/donations/${donation.id}`,
			data: donation
		});
	}

	updateCartProduct(cartType, updatedProduct) {
		var product = _.cloneDeep(updatedProduct);

		// We want to only send the product code
		product.product = product.product["ProductCode"];
		return this.put({
			url: `/api/carts/${cartType}/products/${product.id}`,
			data: product
		});
	}

	completeCheckout(data, options) {
		var reCAPTCHAAction;

		if (data.isPledgeStatementCart) {
			reCAPTCHAAction = StringConstants.ReCAPTCHAActions.PledgeStatementCheckout;
		} else {
			switch(options.checkoutType) {
				case StringConstants.CheckoutTypes.ApplePay:
					reCAPTCHAAction = StringConstants.ReCAPTCHAActions.AppleCheckout;
					break;
				case StringConstants.CheckoutTypes.GooglePay:
					reCAPTCHAAction = StringConstants.ReCAPTCHAActions.GoogleCheckout;
					break;
				case StringConstants.CheckoutTypes.PayPal:
					reCAPTCHAAction = StringConstants.ReCAPTCHAActions.PaypalCheckout;
					break;
				default:
					reCAPTCHAAction = StringConstants.ReCAPTCHAActions.Checkout;
					break;
			}
		}

		return this.post({
			url: "/api/checkout",
			data,
			reCAPTCHA: true,
			reCAPTCHAAction
		});
	}

	getGroupCodeData(data) {
		return this.get({
			url: "/api/groupcode/" + data.groupCode + "?eventCode=" + data.eventCode
		});
	}

	getShippingQuote(data) {
		return this.post({
			url: "/api/shippingquote",
			data: {
				address: data.address.line1,
				addressId: data.address.id,
				city: data.address.city,
				company: data.company,
				country: data.address.country,
				includeErrors: false,
				inventoryItems: data.products,
				postalCode: data.address.postalCode,
				shippingMethods: data.allowedShippingMethods,
				state: data.address.state,
				warehouse: data.warehouse
			}
		});
	}

	getSubscriptionTaxControlRecord() {
		return this.get({
			url: "/api/x01/SUBSALESTX"
		});
	}

	getShippingTaxId() {
		return this.get({
			url: "/api/x01/SHIPTAXID"
		});
	}

	getTaxQuote(data) {
		return this.post({
			data: data,
			url: "/api/taxquote"
		});
	}

	removeGroupCodeCookie(data) {
		return this.delete({
			url: "/api/removegroupcode"
		});
	}

	_createCartAction(cartItemId, itemType, action, cartType) {
		var cartAction = { cartType };
		switch (itemType) {
			case Constants.CART_ITEM_EVENT:
				cartAction.eventAttendees = [cartItemId];
				break;
			case Constants.CART_ITEM_PROJECT:
				cartAction.donations = [cartItemId];
				break;
			case Constants.CART_ITEM_PRODUCT:
				cartAction.products = [cartItemId];
				break;
			case Constants.CART_ITEM_SUBSCRIPTION:
				cartAction.subscriptions = [cartItemId];
				break;
			default:
				var defer = new $.Deferred();
				return defer.reject(`Could not ${action} item with type ${itemType} and id ${cartItemId}.`);
		}

		return cartAction;
	}
};

module.exports = new CheckoutApi();
